// extracted by mini-css-extract-plugin
module.exports = {"expand":"_2dAXCYcHXB7uYuDMeVF-8H"};